import axios from 'axios';
import consts from '../consts';
import { initialize } from 'redux-form';
import {
    setErroAPI,
    setSuccess
} from '../common/toast/toast';

const API = `${consts.API_URL}/abastecimento`;

export const ABASTECIMENTO_MODO_TELA =
    'ABASTECIMENTO_MODO_TELA';
export const ABASTECIMENTO_AGUARDANDO =
    'ABASTECIMENTO_AGUARDANDO';
export const ABASTECIMENTO_LISTADO =
    'ABASTECIMENTO_LISTADO';
export const ABASTECIMENTO_OPCOES =
    'ABASTECIMENTO_OPCOES';

const numero = valor => {
    if (valor === null || valor === undefined || valor === '') {
        return null;
    }

    const texto = valor.toString();
    const retorno = Number(
        texto.includes(',')
            ? texto.replace(/\./g, '').replace(',', '.')
            : texto
    );

    return Number.isFinite(retorno) ? retorno : null;
};

const dataHoraUtc = valor => {
    if (
        !valor ||
        /Z$/i.test(valor) ||
        /[+-]\d{2}:\d{2}$/.test(valor)
    ) {
        return valor;
    }

    const data = new Date(valor);
    return Number.isNaN(data.getTime())
        ? valor
        : data.toISOString();
};

const normalizar = registro => ({
    ...registro,
    datahora_abastecimento:
        dataHoraUtc(registro.datahora_abastecimento),
    id_fornecedor:
        registro.origem === 'POSTO'
            ? Number(registro.id_fornecedor) || null
            : null,
    id_veiculo: Number(registro.id_veiculo) || null,
    id_usuario: Number(registro.id_usuario) || null,
    quantidade: numero(registro.quantidade),
    valor_total: numero(registro.valor_total),
    odometro: numero(registro.odometro),
    horimetro: numero(registro.horimetro)
});

export const setModoTela = (modo, registro = {}) => ({
    type: ABASTECIMENTO_MODO_TELA,
    payload: {
        modo,
        registro
    }
});

export const setAguardando = aguardando => ({
    type: ABASTECIMENTO_AGUARDANDO,
    payload: aguardando
});

export function initForm(registro = {}) {
    let datahora = registro.datahora_abastecimento;

    if (datahora) {
        const data = new Date(datahora);

        if (!Number.isNaN(data.getTime())) {
            data.setMinutes(
                data.getMinutes() - data.getTimezoneOffset()
            );
            datahora = data.toISOString().substring(0, 16);
        }
    } else {
        const data = new Date();
        data.setMinutes(
            data.getMinutes() - data.getTimezoneOffset()
        );
        datahora = data.toISOString().substring(0, 16);
    }

    return initialize('abastecimentoForm', {
        origem: 'POSTO',
        quantidade: 0,
        valor_total: 0,
        ...registro,
        datahora_abastecimento: datahora
    });
}

export function getLista() {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            const resp = await axios.get(API);

            dispatch({
                type: ABASTECIMENTO_LISTADO,
                payload: resp.data
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function getOpcoes() {
    return async dispatch => {
        try {
            const resp = await axios.get(`${API}/opcoes`);

            dispatch({
                type: ABASTECIMENTO_OPCOES,
                payload: resp.data
            });
        } catch (erro) {
            setErroAPI(erro);
        }
    };
}

export function salvar(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));
            const dados = normalizar(registro);

            if (dados.id) {
                await axios.put(API, dados);
            } else {
                await axios.post(API, dados);
            }

            setSuccess(
                dados.id
                    ? 'Abastecimento atualizado.'
                    : 'Abastecimento incluído.'
            );
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function excluir(registro) {
    return async dispatch => {
        try {
            dispatch(setAguardando(true));

            await axios.delete(API, {
                params: {
                    id: registro.id
                }
            });

            setSuccess('Abastecimento excluído.');
            dispatch(getLista());
            dispatch(setModoTela('lista'));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}
